import type { FC } from 'react';
import { useCallback, useEffect, useState } from 'react';
import { useMobileOrientation } from 'react-device-detect';
import { Trans, useTranslation } from 'next-i18next';
import { aviatrixGameId } from '@mwl/core-lib';
import aviatrixImageSrc from '@public/assets/avaitrix/images/aviatrix.webp';
import { Button } from '@/components/Button/Button';
import { Image } from '@/components/Image/Image';
import type { PopupClasses } from '@/components/Popup/Popup';
import { Popup } from '@/components/Popup/Popup';
import { useTypedDispatch, useTypedSelector } from '@/hooks';
import { selectAviatrixPopupIsOpen } from '@/store/features/ui/selectors';
import { toggleAviatrixPopup } from '@/store/features/ui/slice';
import type { PopupAviatrixProps } from './PopupAviatrix.types';
import styles from './PopupAviatrix.module.scss';
export const PopupAviatrix: FC<PopupAviatrixProps> = ({
  portalContainer,
  gameId
}) => {
  const {
    t
  } = useTranslation('casino');
  const isAviatrixPopupShow = useTypedSelector(selectAviatrixPopupIsOpen);
  const [show, setShow] = useState(false);
  const {
    isLandscape,
    isPortrait
  } = useMobileOrientation();
  const dispatch = useTypedDispatch();
  const popupClasses: PopupClasses = {
    wrapper: cn(styles.popupWrapper, {
      [styles.landscape]: isLandscape,
      [styles.portrait]: isPortrait
    }),
    container: styles.popupContainer,
    overlay: styles.popupOverlay
  };
  useEffect(() => {
    if (isAviatrixPopupShow && gameId === aviatrixGameId) {
      setShow(true);
    }
  }, [gameId, isAviatrixPopupShow]);
  const handleClose = useCallback(() => {
    setShow(false);
    dispatch(toggleAviatrixPopup(false));
  }, [dispatch]);
  useEffect(() => {
    return () => {
      dispatch(toggleAviatrixPopup(false));
    };
  }, [dispatch]);
  return <Popup className={styles.popupRoot} classes={popupClasses} portalContainer={portalContainer} onClose={handleClose} show={show} isDisableBodyScroll={false} data-sentry-element="Popup" data-sentry-component="PopupAviatrix" data-sentry-source-file="PopupAviatrix.tsx">
      <div className={styles.root}>
        <Image src={aviatrixImageSrc} width={170} height={45} alt="aviatrix" data-sentry-element="Image" data-sentry-source-file="PopupAviatrix.tsx" />
        <div className={styles.description}>
          <Trans i18nKey="play_aviatrix_popup.description" components={[<span key={0} className={styles.aviatrix} />]} ns="casino" data-sentry-element="Trans" data-sentry-source-file="PopupAviatrix.tsx">
            {`The game Aviator from the provider Spribe is not available in your region. We offer <0>Aviatrix</0> - an alternative game with large cashouts inside.`}
          </Trans>
        </div>
        <Button as="button" onClick={handleClose} className={styles.button} fontSize="lg" fontWeight="bold" size="md" fullWidth align="center" color="red" rounded data-sentry-element="Button" data-sentry-source-file="PopupAviatrix.tsx">
          {t('play_aviatrix_popup.button', 'Play')}
        </Button>
      </div>
    </Popup>;
};